module.exports = __webpack_public_path__ + "img/arrow-up.390c3814.svg";